import { useEffect, useState } from 'react';
import React from 'react'
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Header from '../../components/Shared/Header';
import LeafAnalysis from '../../components/Analysis/Leaves/LeafAnalysis';
import SoilAnalysis from '../../components/Analysis/Soil/SoilAnalysis';
import WaterAnalysis from '../../components/Analysis/Water/WaterAnalysis';
import SoilSolutionAnalysis from '../../components/Analysis/SoilSolution/SoilSolutionAnalysis';
import backIcon from "../../assets/icons/backIcon.svg";
import { getExploitationInfo } from '../../Utils/exploitations/exploitations';
import { useSelector } from 'react-redux';



function AnalysisPage() {
  const { exploitationId, analysisType } = useParams();
  const [currentExploitation, setCurrentExploitation] = useState(null);
  const userRole = useSelector((state) => state.user.userRole.name);

  const userLink = () => {
        if (userRole === 'client') {
          return '/client';
        } else if (userRole === 'admin' || userRole === 'superadmin') {
          return '/admin';
        } else if (userRole === 'domain_manager') {
          return '/domain-manager';
        } else if (userRole === 'exploitation_manager') {
          return '/exploitation-manager';
        }
      };

  const analysisTypes = [
    { key: 'sol', label: 'Sol'},
    { key: 'eau', label: 'Eau'},
    { key: 'solution-sol', label: 'Solution du sol' },
    { key: 'feuilles', label: 'Feuilles' }
  ];


  useEffect(() => {
    const fetchExploitation = async () => {
      try {
        const res = await getExploitationInfo(exploitationId);
        setCurrentExploitation(res.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
      }
    };

    fetchExploitation();
  }, [exploitationId]);


  const renderAnalysisComponent = () => {
    switch (analysisType) {
      case 'sol':
        return <SoilAnalysis />;
      case 'eau':
        return <WaterAnalysis />;
      case 'solution-sol':
        return <SoilSolutionAnalysis />;
      case 'feuilles':
        return <LeafAnalysis />;
      default:
        return <SoilAnalysis />;
    }
  }

  const navigatetoExpPage = () => {
    if (userRole === 'client' || userRole === 'admin' || userRole === 'superadmin') {
      return `${userLink()}/exploitation/all`;
    } else {
      return `${userLink()}/exploitations`;
    }
  }



  return (
    <div className="bg-white h-full">
      <Header title={`
                ${currentExploitation?.exploitation_name} - ${analysisTypes.find(type => type.key === analysisType)?.label} 
              `} />
      <div className="h-[calc(100%-100px)] p-6">
        <Link
          to={navigatetoExpPage()}
          className="cursor-pointer flex pl-5 gap-2 mt-4"
        >
          <img src={backIcon} alt="" className="w-5" />{" "}
          <div className="font-semibold text-base text-indigo-600">
            {" "}
            Retour
          </div>
        </Link>
        <div>
          {renderAnalysisComponent()}
        </div>
      </div>
    </div>
  );
}

export default AnalysisPage;
